import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Reusable insight/article card in editorial (BCG) style
const ArticleCard = ({ item, size = "md" }) => {
  const isLarge = size === "lg";
  return (
    <Link
      to="/insights"
      className="group block hover-zoom"
    >
      <div
        className={`relative overflow-hidden rounded-lg bg-slate-100 ${
          isLarge ? "aspect-[16/10]" : "aspect-[4/3]"
        }`}
      >
        <img
          src={item.image}
          alt={item.title}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>
      <div className="pt-5">
        <div className="flex items-center gap-3 mb-2">
          <span className="text-xs font-700 uppercase tracking-wider text-[#0a6ed1]">
            {item.category}
          </span>
          {item.readTime && (
            <span className="text-xs text-slate-400">{item.readTime}</span>
          )}
        </div>
        <h3
          className={`font-display font-700 text-[#0a2540] leading-snug group-hover:text-[#0a6ed1] transition-colors ${
            isLarge ? "text-2xl md:text-3xl" : "text-lg md:text-xl"
          }`}
        >
          {item.title}
        </h3>
        <p className="mt-3 text-slate-500 text-[15px] leading-relaxed">
          {item.excerpt}
        </p>
        <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-600 text-[#0a2540] group-hover:gap-3 transition-all">
          Read more <ArrowRight className="w-4 h-4 text-[#0a6ed1]" />
        </span>
      </div>
    </Link>
  );
};

export default ArticleCard;
